import React from 'react';
import { RecordingAsset,WidgetSettings } from 'types';

import DynamicGridViewer from 'components/pages/Grids/DynamicGridViewer/DynamicGridViewer';
import RecordingCardContainer from 'components/widgets/CardView/Recording/RecordingContainer/RecordingContainer';
import { WidgetProviderData } from 'context/widgetProvider/types';
import WidgetProvider from 'context/widgetProvider/widgetProvider';

interface Props {
  type: string;
  settings: WidgetSettings;
  data: WidgetProviderData<RecordingAsset>;
}

function RecordingsGridContainer({ type, settings, data }: Props) {
  return (
    <WidgetProvider<RecordingAsset> isGrid type={type} settings={settings} data={data}>
      <DynamicGridViewer<RecordingAsset>>
        {({ imageHeight, itemWidth, data: item }) => (
          <RecordingCardContainer imageHeight={imageHeight} itemWidth={itemWidth} data={item} />
        )}
      </DynamicGridViewer>
    </WidgetProvider>
  );
}

export default React.memo(RecordingsGridContainer);
